import { Loader2 } from 'lucide-react'

export function RouteLoading() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]" aria-busy="true">
      <h1 className="sr-only">Loading</h1>
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
    </div>
  )
}

export function FullPageLoading() {
  return (
    <div className="flex items-center justify-center min-h-screen" aria-busy="true">
      <h1 className="sr-only">Loading</h1>
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
    </div>
  )
}
